import { h, Component } from 'preact';
import style from './style.less'
import {classNames} from 'lib/helpers'
export default (props)=>{
    const classes = [
        props.class,
        style.icon
    ]

    switch(props.type){
        case 'VS':
            return <div class={classNames(...classes)}>
                <img src='https://usa.visa.com/dam/VCOM/regional/lac/ENG/Default/Partner%20With%20Us/Payment%20Technology/visapos/full-color-800x450.jpg' />
            </div>
        case 'MC':
            return <div class={classNames(...classes)}>
                <img src='https://brand.mastercard.com/content/dam/mccom/brandcenter/thumbnails/mastercard_circles_92px_2x.png' />
            </div>
        case 'DC':
            return <div class={classNames(...classes, style.discover)}>
                <img src='https://www.discover.com/global/images/discover-logo.png' />
            </div>
    }
}


// WEBPACK FOOTER //
// ./components/elements/CreditCardIcon/index.js